module.exports = __webpack_public_path__ + "static/SuisseIntl-ed75f16a28b5e46a634596bcf6b193f1.woff";